"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;

var _stylitas = require("@creditas/stylitas");

var _styleUtilities = require("@creditas-lab/style-utilities");

var _styledTools = require("styled-tools");

var _arrows = _interopRequireDefault(require("./icons/arrows.svg"));

var thumbStyle = function thumbStyle(props) {
  return (0, _stylitas.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  appearance: none;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: ", ";\n  background-image: url(", ");\n  background-repeat: no-repeat;\n  background-position: center center;\n  box-shadow: 0px -2px 16px rgba(0, 0, 0, 0.04),\n    0px 4px 24px rgba(0, 0, 0, 0.08);\n  margin-top: -20px;\n  cursor: pointer;\n  outline: none;\n  border: none;\n  position: relative;\n\n  ", "\n"])), (0, _styledTools.theme)('colorNeutralWhite')(props), _arrows.default, _styleUtilities.media.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: 48px;\n    height: 48px;\n    margin-top: -24px;\n  "]))));
};

var thumb = function thumb(props) {
  return (0, _stylitas.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  &::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    ", "\n  }\n\n  &::-moz-range-thumb {\n    -moz-appearance: none;\n    ", "\n  }\n\n  &::-ms-thumb {\n    ", "\n  }\n"])), thumbStyle(props), thumbStyle(props), thumbStyle(props));
};

var trackStyle = function trackStyle(props) {
  return (0, _stylitas.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 1px;\n  cursor: pointer;\n  background: linear-gradient(\n    to right,\n    ", " 0%,\n    ", " ", "%,\n    ", " ", "%,\n    ", " 100%\n  );\n"])), (0, _styledTools.theme)('colorNeutral90')(props), (0, _styledTools.theme)('colorNeutral90')(props), (0, _styledTools.prop)('filled')(props), (0, _styledTools.theme)('colorNeutral15')(props), (0, _styledTools.prop)('filled')(props), (0, _styledTools.theme)('colorNeutral15')(props));
};

var track = function track(props) {
  return (0, _stylitas.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  &::-webkit-slider-runnable-track {\n    ", "\n  }\n\n  &::-moz-range-track {\n    ", "\n  }\n\n  &::-ms-track {\n    ", "\n  }\n"])), trackStyle(props), trackStyle(props), trackStyle(props));
};

var StyledInput = _stylitas.styled.input(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  -webkit-appearance: none;\n  width: 100%;\n  height: auto;\n  min-height: 60px;\n  background: transparent;\n  outline: none;\n  overflow: visible;\n\n  ", "\n  ", "\n"])), thumb, track);

exports.Input = StyledInput;